<template>
<div>
    <div class="inMain_box">
        <div class="hat clear">
            {{type}}
            <el-button class="btn" @click="add()">Add</el-button>
        </div>
        <el-table
        :data="tableData"
        border
        class="venue_table"
        style="width: 100%">
            <el-table-column
            prop="incomeName"
            align="center"
            label-class-name="roster_th"
            class-name="roster_row"
            :label="`${type} Name`">
            </el-table-column>
            <el-table-column
            prop="name"
            align="center"
            label-class-name="roster_th"
            class-name="roster_row"
            label="Commission">
                <template slot-scope="scope">
                    <div v-if="scope.row.incomeType === 2">{{scope.row.commission?scope.row.commission +'%':'0%'}}</div>
                    <div v-else-if="scope.row.incomeType === 1" style="word-break:break-word">{{scope.row.commission?`$${scope.row.commission}/item`:`$0.00/item`}}</div>
                    <div v-else-if="scope.row.incomeType === 3">-</div>
                </template>
            </el-table-column>
            <el-table-column
            prop="address"
            align="center"
            label-class-name="roster_th"
            class-name="roster_row"
            label="Operating">
                <template slot-scope="scope">
                    <i class="el-icon-edit-outline" style="font-size:26px;cursor:pointer;" @click="editExtra(scope.row)"></i>
                    <i v-if="!scope.row.isCanNotBeDeleted" class="el-icon-delete" style="font-size:26px;cursor:pointer;margin-left:10px;color:#D13A90" @click="delExtra(scope.row)"></i>
                </template>
            </el-table-column>
            <template slot="empty">
                -
            </template>
        </el-table>
    </div>

    <el-dialog
    :title="dioTit"
    :visible.sync="extraDio"
    :modal-append-to-body="false"
    :show-close='false'
    class="editCardDio"
    :close-on-click-modal='false'
    width="840px"
    center>
        <!--<div v-if="editMsg.incomeName!='Open Table Bookings'">-->
        <div>
            <div class="tag_tit">{{type}} Name</div>
            <el-input v-model="name" maxlength="50" :class="{'err':isName}" @blur="nameBlur" :disabled="!modifyFlag" class="borderNone"></el-input>
        </div>
        <div class="tag_tit">{{type === 'Revenue' || type === 'Delivery' ? 'Commission' : 'Fee'}}</div>
        <div v-if="type === 'Revenue' || type === 'Delivery'">
            <el-input v-model="commis" @input="commis = commis.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'),
            commis = ((type === 'Revenue' || type === 'Delivery') && commis > 100) ? 100 : commis"
                :maxlength="dioTit=='Edit Open Table Bookings'?10:6" class="borderNone" :class="{'err':isCommis}" @blur="nameCommis">
                <span slot="prefix" class="increaseIcon" v-if="type === 'Expenses'">$</span>
                <span slot="suffix" class="increaseIcon">{{type === 'Revenue' || type === 'Delivery'?'%':'/item'}}</span>
            </el-input>
        </div>
        <div class="twin clear" v-else>
            <div class="twin-left clear">
                <div class="check" :class="{'checked': expensesChoosed === 1}" @click="expensesChoosed = 1"></div>
                <div class="label">Direct Fee</div>
            </div>
            <div class="twin-right clear">
                <div class="check" :class="{'checked': expensesChoosed === 2}" @click="expensesChoosed = 2"></div>
                <div class="input">
                    <el-input v-model="commis" @input="commis = commis.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'),
                    commis = ((type === 'Revenue' || type === 'Delivery') && commis > 100) ? 100 : commis"
                        :maxlength="dioTit=='Edit Open Table Bookings'?10:6" class="borderNone" :class="{'err':isCommis && expensesChoosed === 2}" @blur="nameCommis">
                        <span slot="prefix" class="increaseIcon" v-if="type === 'Expenses'">$</span>
                        <span slot="suffix" class="increaseIcon">{{type === 'Revenue' || type === 'Delivery'?'%':'/item'}}</span>
                    </el-input>
                </div>
            </div>
        </div>
        <!-- <div class="errmsg" v-if="type === 'Revenue' || type === 'Delivery'">No input default no commission.</div> -->
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancelOperate('update')" class="cardCanBtn">Cancel</el-button>
            <el-button @click="confirmMsg" class="cardConBtn">Confirm<i class="el-icon-loading" v-if="requesting" style="margin-left: 10px"></i></el-button>
        </span>
    </el-dialog>

    <el-dialog
    title=""
    :visible.sync="delStreamDio"
    :modal-append-to-body="false"
    :show-close='false'
    class="editCardDio"
    :close-on-click-modal='false'
    width="840px"
    center>
        <div class="newDelTit">After deletion, the revenue that has been entered this week will be cleared. Are you sure you want to continue?</div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancelOperate('delete')" class="cardCanBtn">Cancel</el-button>
            <el-button @click="delTrue" style="color:#FF4E4E;border-color:#FF4E4E;margin-left: 10px" class="cardConBtn">Delete<i class="el-icon-loading" v-if="requesting"></i></el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import api from '../../api/api'
export default {
    inject: ["reload", "hidden", "show2"],
    data() {
        return {
			dioTit: `Add a new ${this.type}`,
			extraDio:false,
			name:'',
			commis:'',

			isName:false,
            isCommis: false,

			delStreamDio:false,
			editMsg:'',
			val:'',

            requesting: false,

            expensesChoosed: 0,

            modifyFlag: true
        }
    },
    props: {
        type: {
            type: String,
            default: ''
        },
        tableData: {
            type: Array,
            default: []
        }
    },
    methods: {
        cancelOperate(type){
            if(this.requesting){
                return
            }
            if (type === 'update'){
                this.extraDio = false
                this.name=''
                this.commis=''
                this.isName=false
            } else {
                this.delStreamDio = false
            }
        },
        add() {
            this.dioTit = `Add a new ${this.type}`
            this.extraDio=true
        },
		delExtra(val){
			this.val= val
			this.delStreamDio = true
		},
		delTrue(){
			const pat = {
				id:this.val.id
			}
			api.delRevenueNew(pat,this.callback)
		},
		editExtra(msg){ // 修改
			this.name=msg.incomeName
            this.modifyFlag=msg.modifyFlag
			this.commis=msg.commission
			this.editMsg=msg
            this.dioTit = `Edit ${this.type}`
            this.extraDio=true
            this.expensesChoosed = msg.incomeType === 3 ? 1 : 2
        },
		confirmMsg(){
			if(!this.name){
				this.isName=true;
				// return
			}
            if(this.commis==='' && this.expensesChoosed !== 1){
				this.isCommis=true;
				// return
			}
            if(!this.name || (this.commis === '' && this.expensesChoosed !== 1) || this.requesting)
                return

            this.requesting = true
			let pat={
				// "commission": (this.type === 'Revenue' || this.type === 'Delivery') ? Number((this.commis/100).toFixed(3)) : Number(this.commis),
                "incomeName": this.name,
                "incomeType": (this.type === 'Revenue' || this.type === 'Delivery') ? 2 : (this.expensesChoosed === 1 ? 3 : 1)
			}
            if (this.expensesChoosed === 1) {
                pat.commission = 0
            } else {
                pat.commission = (this.type === 'Revenue' || this.type === 'Delivery') ? Number((this.commis/100).toFixed(3)) : Number(this.commis)
            }

			if(this.dioTit == `Add a new ${this.type}`){
                pat.expensesType = this.type === 'Revenue' ? 1 : (this.type === 'Delivery' ? 2 : 3),
				api.addStreanInfo(pat,this.callback)
			}else{
				pat.id=this.editMsg.id
				api.editStreanInfo(pat,this.callback)
			}
		},
        callback(res,status){
            this.requesting = false
			let {code , message ,data} = res.data
            if(code==0){
                // this.reload()
                this.$emit('refresh')
                this.extraDio = false
            }else{
                Utils.alert2('',message,'error')
            }
		},
		nameBlur(){ // name失去焦点
			if(this.name.replace(/\s+/g,'') === 0)
				this.isName=true;
			else
			    this.isName=false;
		},
        nameCommis(){
			if(!this.commis.replace(/\s+/g,'') === 0)
				this.isCommis=true;
			else
			    this.isCommis=false;
		},
	},
	watch: {
		extraDio(n,o){
			if(!n){
				this.isName = false
				this.name=''
                this.modifyFlag = true
				this.commis=''
                this.expensesChoosed = 0
			}
		},
		extraDioTwo(n,o){
			if(!n){
				this.isName = false
                this.modifyFlag = true
				this.name=''
				this.commis=''
                this.expensesChoosed = 0
			}
		}
	},
}
</script>

<style lang="scss">
.twin{
    .twin-left{
        float: left;
        width: 49%;
        font-size: 20px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-color);
        line-height: 50px;
    }
    .twin-right{
        float: right;
        width: 49%;
    }
    .check{
        width: 18px;
        height: 50px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 17px auto;
        background-image: url("../../assets/p2.png");
        float: left;
        margin-right: 15px;
        cursor: pointer;
    }
    .checked{
        background-image: url("../../assets/cc.png");
    }
    .label{
        float: left;
    }
    .input{
        width: 320px;
        float: left;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/setting/streambox.vue